import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { addRfqEp as endpoint } from "../apiEndpoints";
import { IAddRFQ } from "../IRfq";

const AddRFQAPI = async ({
    rfq
}: IAddRFQ) => {

    const url = endpoint()
    const options: FetchOptions = {
        method: "POST",
        body: rfq,
    }

    return fetchInterceptor(url, options)


};

export default AddRFQAPI;